import { render, staticRenderFns } from "./saveSteps.vue?vue&type=template&id=1487995c&scoped=true"
import script from "./saveSteps.vue?vue&type=script&lang=js"
export * from "./saveSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1487995c",
  null
  
)

export default component.exports